import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Runs `onConsume` once when the URL carries `?<key>=1`, then removes that
 * param while leaving the rest of the query string intact. Used for one-shot
 * signals from external redirects, e.g. returning from an Authentik flow.
 */
export const useConsumeSearchFlag = (
  key: string,
  onConsume: () => void,
  enabled = true,
) => {
  const { pathname, search, hash } = useLocation();
  const history = useHistory();
  const hasConsumedRef = useRef(false);

  useEffect(() => {
    if (!enabled || hasConsumedRef.current) return;

    const params = new URLSearchParams(search);
    if (params.get(key) !== '1') return;

    hasConsumedRef.current = true;
    onConsume();
    params.delete(key);
    history.replace({ pathname, search: params.toString(), hash });
  }, [enabled, hash, history, key, onConsume, pathname, search]);
};
